<template>
<div class="dashboard">
  <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <router-link to="/pedidos">
            <p v-if="isA('client')" class="card-category">Meus pedidos</p>
            <p v-else class="card-category">Pedidos</p>
            <h3 class="card-title">{{orders.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-sm" to="/pedidos">
              Pedidos
            </router-link>
            <router-link class="btn btn-primary btn-sm" to="/demandas" v-if="isLink">
              Demandas
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentUser.roles.includes('seller')" class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <router-link to="/clientes">
            <p class="card-category">
              Clientes
            </p>
            <h3 class="card-title">{{clients.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-icon" to="/clientes">
              Clientes
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSupplier" class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <router-link to="/ofertas">
            <p class="card-category">
              Ofertas
            </p>
            <h3 class="card-title">{{offers.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-sm" to="/cadastrar-oferta">
              Cadastrar oferta
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSupplier" class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <router-link to="/produtos">
            <p class="card-category">
              Produtos
            </p>
            <h3 class="card-title">{{product_variations.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-sm" to="/cadastrar-produto">
              Cadastrar produto
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6" v-if="isManager">
      <div class="card">
        <div class="card-header">
          <router-link to="/fornecedores">
            <p class="card-category">
              Fornecedores
            </p>
            <h3 class="card-title">{{suppliers.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-sm" to="/cadastrar-fornecedor">
              Cadastrar fornecedor
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6" v-if="isLink">
      <div class="card">
        <div class="card-header">
          <router-link to="/redes">
            <p class="card-category">
              Redes
            </p>
            <h3 class="card-title">{{organizations.length}}</h3>
          </router-link>
        </div>
        <div class="card-footer">
          <div class="stats">
            <router-link class="btn btn-primary btn-sm" to="/cadastrar-rede">
              Cadastrar rede
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isSupplier">
    <h4>Últimas ofertas</h4>
    <div v-if="offers && offers.length">
      <b-table stacked="lg" :fields="table_fields" :items="offers.slice(0, 12)" :sort-by="'name'">
        <template slot="thumb" slot-scope="data">
          <router-link :to="'/editar-oferta/'+ data.item._id" class="product_td">
            <product-image :product="data.item.product_variation" :product_variation="data.item.product_variation" css_class="thumb" />
          </router-link>
        </template>
        <template slot="product_variation" slot-scope="data">
          <router-link :to="'/editar-oferta/'+ data.item._id" class="product_td">
            {{data.value.name}}
          </router-link>
        </template>
        <template slot="manufacturing_date" slot-scope="data">
          <div v-if="data.item.product_variation && data.item.product_variation.duration && data.item.product_variation.duration.value && data.value">
            {{data.value | moment("DD/MM/YYYY")}}
            <br>
            <small>Vence {{data.value | moment("add", data.item.product_variation.duration.value + ' ' + date_unit[data.item.product_variation.duration.unit]) | moment('from', 'now')}}</small>
          </div>
        </template>
        <template slot="address" slot-scope="data">
          <small v-if="data.value">{{data.value.description}}</small>
        </template>
        <template slot="qtd" slot-scope="data">
          {{data.value - data.item.qtd_ordered}} unidades
        </template>
        <template slot="final_price" slot-scope="data">
          {{data.value | moeda}}
        </template>
        <template slot="actions" slot-scope="data">
          <div class="btn-group btn-group-sm">
            <router-link :to="'/editar-oferta/'+ data.item._id" class="btn btn-primary">
              <i class="fa fa-pencil"></i>
            </router-link>
            <a @click="remove(data.item._id)" class="btn btn-secondary">
              <i class="fa fa-close"></i>
            </a>
          </div>
        </template>
      </b-table>
    </div>
    <br>
    <h4>Últimos produtos cadastrados</h4>
    <br>
    <div class="row">
      <div class="col-md-4" v-for="(product_variation, index) in product_variations.slice(0, 12)" :key="index">
        <div class="card card-product">
          <div class="card-headerno text-center no-padding">
            <router-link :to="'/editar-produto/'+product_variation._id">
              <div class="card-img">
                <product-image :product="product_variation" css_class="card-img-top" />
              </div>
            </router-link>
          </div>
          <div class="card-body">
            <div class="card-title">
              <router-link :to="'/editar-produto/'+product_variation._id">
                {{product_variation.name}}
              </router-link>
            </div>
            <div class="card-description">
              <small>{{product_variation.description}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import ProductImage from '@/components/ProductImage';

export default {
  name: 'Dashboard',

  data() {
    return {
      organizations: [],
      suppliers: [],
      product_variations: [],
      offers: [],
      orders: [],
      clients: [],
      date_unit: {
        'Dias': 'days',
        'Meses': 'months',
        'Anos': 'years'
      },
      table_fields: [
        {
          key: 'thumb',
          label: '',
          class: 'td-logo'
        },
        {
          key: 'product_variation',
          label: 'Oferta',
          sortable: true
        },
        {
          key: 'address',
          label: 'Origem do envio',
          sortable: true
        },
        {
          key: 'manufacturing_date',
          label: 'Data de fabricação',
          sortable: true
        },
        {
          key: 'final_price',
          label: 'Preço final',
          sortable: true
        },
        {
          key: 'qtd',
          label: 'Disponível',
          sortable: true
        },
      ]
    }
  },
  created() {
    if (this.isLink) {
      axios.get('organizations').then(response => {
        this.organizations = response.data
      }).catch(this.showError)
    }

    if (this.isManager) {
      axios.get('suppliers').then(response => {
        this.suppliers = response.data
      }).catch(this.showError)
    }

    if (this.isSupplier) {
      axios.get('product_variations').then(response => {
        this.product_variations = response.data
      }).catch(this.showError)

      axios.get('offers', {
        params: {
          populate: 'product_variation',
          published: true
        }
      }).then(response => {
        this.offers = response.data
      }).catch(this.showError)
    }

    if (this.currentUser.roles.includes('seller')) {
      axios.get('users', { params: { role: 'client' } }).then(response => {
        this.clients = response.data
      }).catch(this.showError)
    }

    axios.get('orders', {
      params: {
        populate: 'items.offer'
      }
    }).then(response => {
      this.orders = response.data.filter(order => order.status < 100)
    }).catch(this.showError)
  },
  components: {
    ProductImage
  }
}
</script>
